import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.ewa)

export const EWA_INSTANCE = service.instanceKey

export const EWA_ENDPOINTS = {
  EMPLOYEES: "/v1/employees",
  LOAN_PROVIDERS: "/v1/loans/providers",
  LOAN_GENERATE: "/v1/loans/generate-details",
  LOAN_REQUEST: "/v1/loans/request",
  UPLOAD_FILE: "/v1/files",
  EMPLOYER_COMPANIES: "/v1/employers/companies",
  CVG_ELIGIBILITY: "/v1/cvg/eligibility",
  WITHDRAWAL_STATUS: "/v1/employer/withdrawals",
  // Employee-facing
  EARNINGS_WALLET: "/v1/earnings/wallet",
  EMPLOYEE_WITHDRAWALS: "/v1/employee/withdrawals",
  FEES_CALCULATE: "/v1/fees/calculate",
  EARNINGS_WITHDRAW: "/v1/earnings/withdraw",
  UPDATE_PIN: "/v1/employees/update-pin",
  WORKPLACES: "/v1/time-attendance/workplaces",
  PROMOTIONS: "/v1/promotions",
} as const

export const ewaService = {
  instanceKey: service.instanceKey,

  getEmployees: (params?: Record<string, any>) =>
    service.get(EWA_ENDPOINTS.EMPLOYEES, params),

  getLoanProviders: () => service.get(EWA_ENDPOINTS.LOAN_PROVIDERS),

  generateLoanDetails: (body: Record<string, any>) =>
    service.post(EWA_ENDPOINTS.LOAN_GENERATE, body),

  submitLoanRequest: (body: Record<string, any>) =>
    service.post(EWA_ENDPOINTS.LOAN_REQUEST, body),

  uploadFile: (formData: FormData) =>
    service.upload(EWA_ENDPOINTS.UPLOAD_FILE, formData),

  getEmployerCompanies: (padeCompanyId: string | number) =>
    service.get(EWA_ENDPOINTS.EMPLOYER_COMPANIES, { padeCompanyId }),

  getCVGEligibility: (params?: Record<string, any>) =>
    service.get(EWA_ENDPOINTS.CVG_ELIGIBILITY, params),

  updateWithdrawalStatus: (id: string | number, body: Record<string, any>) =>
    service.post(
      `${EWA_ENDPOINTS.WITHDRAWAL_STATUS}/${id}/approval-status`,
      body
    ),

  getEarningsWallet: (params?: Record<string, any>) =>
    service.get(EWA_ENDPOINTS.EARNINGS_WALLET, params),

  getEmployeeWithdrawals: (params?: Record<string, any>) =>
    service.get(EWA_ENDPOINTS.EMPLOYEE_WITHDRAWALS, params),

  calculateFee: (amount: string | number) =>
    service.get(EWA_ENDPOINTS.FEES_CALCULATE, { amount }),

  withdraw: (body: Record<string, any>) =>
    service.post(EWA_ENDPOINTS.EARNINGS_WITHDRAW, body),

  updatePin: (body: Record<string, any>) =>
    service.post(EWA_ENDPOINTS.UPDATE_PIN, body),

  getWorkplaces: (params?: Record<string, any>) =>
    service.get(EWA_ENDPOINTS.WORKPLACES, params),
  getWorkplaceById: (workplaceId: string | number) =>
    service.get(`${EWA_ENDPOINTS.WORKPLACES}/${workplaceId}`),

  getPromotions: (params?: Record<string, any>) =>
    service.get(EWA_ENDPOINTS.PROMOTIONS, params),
}
